export default __webpack_public_path__ + "static/media/PlayNYC.17341da3.pdf";